import { ApiService } from '../../../services/api_service';
import { DataService } from '../../../services/data_service';
import { IDs } from '../../../helpers/IDs';
import { Md5 } from 'ts-md5/dist/md5';

export function submitKennzahlen(data: any, jahr: number, dataService: DataService, item_found?: any, res_roh?: any[], callback?: () => void): void {
    const onSubmitDone = () => {
        if (typeof callback === 'function') {
            callback();
        }
    };
    const values_roh = res_roh.filter((r: any) => r.jahr === jahr);
    if (!ApiService.unternehmenInternal) {
        // console.log('submitKennzahlen', 'no unternehmenInternal');
        onSubmitDone();
        return;
    }
    const kenn_def: any[] = data[IDs.ENT_KENNZAHLEN_DEFINTION] || [];
    const unternehmen: any = (data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};

    if (!Object.keys(unternehmen).length) {
        // console.log('submitKennzahlen', 'no unternehmen');
        onSubmitDone();
        return;
    }
    const kenn_jahr = (data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {};
    const gewerk = unternehmen.gewerk_tid_orig || unternehmen.gewerk_tid;
    const situation = unternehmen.betriebliche_situation_orig || unternehmen.betriebliche_situation;

    // console.log('submitKennzahlen unternehmen, gewerk, situation', unternehmen, gewerk, situation);
    if (!gewerk || (!situation && gewerk !== 148) || gewerk === 147) {
        // console.log('submitKennzahlen', 'no gewerk/situation');
        onSubmitDone();
        return;
    }
    const tid = unternehmen.tid;
    const pseudo: string = `SUB_G${gewerk}_U${tid}`;
    // console.log('KENN DEF: ', kenn_def, kenn_jahr);
    const submit_data: any[] = [];
    const hashes: any = {};
    let changes = 0;

    Object.keys(kenn_jahr).forEach((kuerzel: string) => {
        const def = kenn_def.find((kd: any) => !kd.is_berechnet && kd.kuerzel === kuerzel);
        const wert = kenn_jahr[kuerzel];
        const roh = values_roh.find((r: any) => r.kuerzel === kuerzel);
        // console.log('Debug K: ', jahr, kuerzel, wert, def);
        if (def && wert) {
            const kuerzel_use = def.kuerzel_db ? def.kuerzel_db : kuerzel;
            let values: any = { jahr, kuerzel: kuerzel_use, wert, name: def.name, changed: false };

            if (roh && roh.wert === wert) {
                // console.log('Unverändert: ', jahr, kuerzel, wert);
                submit_data.push(values);
            } else {
                values = { ...values, changed: true };
                const hash: string = Md5.hashAsciiStr(JSON.stringify(values)).toString();
                // console.log('Neu/Verändert: ', jahr, kuerzel, wert);
                if (!hashes[hash]) {
                    submit_data.push(values);
                    hashes[hash] = true;
                    changes++;
                }
            }
        } else {
            // console.log('NOT FOUND')
        }
    });
    if (changes === 0 /*submit_data.length === 0*/) {
        if (item_found) {
            // Das Item kann gelöscht werden
            const del_data = {
                tid: item_found ? item_found.tid : 0,
                unternehmen_tid: tid
            };
            dataService.delData(IDs.ENT_KENNZAHLEN_IMPORT, IDs.MOD_ETOOL_ADMIN, del_data, undefined, () => {
                console.log('Gelöscht!', jahr, tid);
            });
        }
        onSubmitDone();
        return; // Keine Daten, keine Speicherung
    }
    let miss = false;
    if (item_found) {
        // console.log('ITEM: ', item_found);
        let comp_data;
        try {
            comp_data = JSON.parse(item_found.daten);
        } catch (e) {
            console.error(e, item_found);
        }
        if (Array.isArray(comp_data)) {
            // Vergleichen
            if (comp_data.length !== submit_data.length) {
                miss = true;
                console.log('MISS ! LENGTH');
            } else {
                comp_data.forEach((d: any) => {
                    const found = submit_data.find((sd: any) => sd.kuerzel === d.kuerzel);
                    if (!found || found.wert !== d.wert) {
                        miss = true;
                        console.log('MISS: ', d.kuerzel, d.wert, (found ? found.wert : null));
                    }
                });
            }
        }
    } else {
        console.log('MISS ! NO ITEM');
        miss = true;
    }
    // console.log('UNT: ', unternehmen);
    const save_data = {
        tid: item_found ? item_found.tid : 0,
        branchen_gewerke_tid: gewerk,
        betriebliche_situation: situation,
        unternehmen: pseudo,
        unternehmen_tid: tid,
        unternehmen_name: ApiService.unternehmenInternal ? ApiService.unternehmenInternal.bezeichnung : '',
        jahr: jahr,
        daten: JSON.stringify(submit_data),
        status: 0,
        stamp_uebertragung: (new Date().getTime() / 1000)
    };
    // console.log('submit savedata', save_data);
    if (miss) {
        dataService.saveData(IDs.ENT_KENNZAHLEN_IMPORT, save_data, undefined, false,
            (suc: boolean, saveTid: number) => {
                // console.log('KSAVE', suc, saveTid);
                // alert('Übertragen!');
                // console.log('submitKennzahlen', 'Save done:', jahr, save_data.unternehmen_tid);
                onSubmitDone();
            },
            IDs.MOD_ETOOL_ADMIN
        );
        // console.log('SUBMIT KENNZAHLEN ', save_data);
        // console.log('submitKennzahlen', 'save', save_data);
    } else {
        // console.log('submitKennzahlen', 'no change');
        onSubmitDone();
    }
}
